module.exports = require("./lib/_stream_writable.js")



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/writable.js
// module id = 598
// module chunks = 0 1